import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SITE_ROUTES } from 'shared/enums/routes.enum';
import { Icon } from '../icon/icon';
import { RouterService } from 'core/services/router.service';
import { TranslateModule } from '@ngx-translate/core';
import { UtilsService } from 'core/services/utils.service';
import { StorageService } from 'core/services/storage.service';
import { PAGES_PERMISSIONS } from 'shared/enums/permissions.enum';
import { AuthAwareComponent } from 'core/base/auth-aware.component';
import { MenuDTO } from 'shared/models/common/menu';
import { TranslationService } from 'core/services/translation.service';
import { AlertService } from 'core/services/alert.service';
import { AuthService } from 'features/auth/auth.service';
import { ChangePassword } from '../dialogs/change-password/change-password';
import { DialogService } from 'core/services/dialog.service';

@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule,
    Icon,
    TranslateModule
  ],
  providers: [
    RouterService,
    AuthService
  ],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar extends AuthAwareComponent implements OnInit {
  menus: MenuDTO[] = [
    {
      title: 'dashboard',
      icon: 'assets/images/common/dashboard-icon-gray.svg',
      activeIcon: 'assets/images/common/dashboard-icon-primary.svg',
      link: SITE_ROUTES.DASHBOARD,
      permissions: PAGES_PERMISSIONS.DASHBOARD
    },
    {
      title: 'companies',
      icon: 'assets/images/common/companies-icon-gray.svg',
      activeIcon: 'assets/images/common/companies-icon-primary.svg',
      link: SITE_ROUTES.COMPANIES_LISTING,
      permissions: PAGES_PERMISSIONS.COMPANIES_LISTING
    },
    {
      title: 'subscriptionPlanManagement',
      icon: 'assets/images/common/packages-icon-gray.svg',
      activeIcon: 'assets/images/common/packages-icon-primary.svg',
      link: SITE_ROUTES.PACKAGES_LISTING,
      permissions: PAGES_PERMISSIONS.PACKAGES_LISTING
    },
    {
      title: 'usersManagement',
      icon: 'assets/images/common/users-icon-gray.svg',
      activeIcon: 'assets/images/common/users-icon-primary.svg',
      link: SITE_ROUTES.USERS_LISTING,
      permissions: PAGES_PERMISSIONS.USERS_LISTING
    },
    {
      title: 'partnersManagement',
      icon: 'assets/images/common/users-icon-gray.svg',
      activeIcon: 'assets/images/common/users-icon-primary.svg',
      link: SITE_ROUTES.PARTNERS_LISTING,
      permissions: PAGES_PERMISSIONS.PARTNERS_LISTING
    },
    {
      title: 'contactMessages',
      icon: 'assets/images/common/chat-icon-gray.svg',
      activeIcon: 'assets/images/common/chat-icon-primary.svg',
      link: SITE_ROUTES.CONTACT_MESSAGES,
      permissions: PAGES_PERMISSIONS.CONTACT_MESSAGES
    },
    {
      title: 'settings',
      icon: 'assets/images/common/settings-icon-gray.svg',
      activeIcon: 'assets/images/common/settings-icon-primary.svg',
      link: SITE_ROUTES.SETTINGS,
      permissions: PAGES_PERMISSIONS.SETTINGS
    },
    {
      title: 'policies',
      icon: 'assets/images/common/policies-icon-gray.svg',
      activeIcon: 'assets/images/common/policies-icon-primary.svg',
      link: SITE_ROUTES.POLICIES_LISTING,
      permissions: PAGES_PERMISSIONS.POLICIES_LISTING
    },
    {
      title: 'Tickets',
      icon: 'assets/images/common/ticket-gray.svg',
      activeIcon: 'assets/images/common/ticket-primary.svg',
      link: SITE_ROUTES.TICKETS,
      permissions: PAGES_PERMISSIONS.TICKETS_LISTING
    },
  ]

  constructor(
    private routerService: RouterService,
    private utilsService: UtilsService,
    storageService: StorageService,
    private translationService: TranslationService,
    private alertService: AlertService,
    private authService: AuthService,
    private dialogService: DialogService
  ) {
    super(storageService);
  }

  isMenuActive(menu: MenuDTO) {
    const currentPath = this.utilsService.splitPathBySlash(window.location.pathname)[2];
    const menuPath = this.utilsService.splitPathBySlash(menu.link)[2];
    return currentPath === menuPath;
  }

  goToMenu(path: string) {
    this.routerService.navigate(path);
  }

  async logout() {
    const logoutConfirmation = this.translationService.getTranslation('logoutConfirmation');
    const { isConfirmed } = await this.alertService.confirmationPopup(logoutConfirmation);
    if (isConfirmed) this.authService.logout().subscribe();
  }

  get permittedMenus() {
    return this.menus.filter(m => m.permissions.some(p => this.hasPermission(p)));
  }

  openConfirmPasswordDialog() {
    this.dialogService.openDialog(ChangePassword)
  }

  getMyProfile() {
    this.authService.getMyProfile().subscribe()
  }

  protected get profilePic() {
    return this.storageService.profilePic;
  }

  ngOnInit(): void {
    this.getMyProfile();
  }
}
